const Footer = () => {
  return (
    <div className="flex items-center justify-center bg-blue-200 py-4">
      Created with ❤️ By. .
      <a href="https://www.linkedin.com/in/astrorock/" target="_blank">
        <u>astrorock</u>
      </a>
      <i class="fa-solid fa-copyright"></i>2023
      <strong>
        Food<span>Fire</span>
      </strong>
    </div>
  );
};
export default Footer;
